import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const MODULE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.MODULE,
  false
);

export const moduleApi = {
  moduleForm: () => apiClient.get(`${MODULE}/form`),

  editModuleForm: Id =>
    apiClient.get(`${MODULE}/form?is_edit=true&module_id=${Id}`),

  createModule: combinedData => apiClient.post(`${MODULE}`, combinedData),

  updateModule: (id, combinedData) =>
    apiClient.put(`${MODULE}/${id}`, combinedData)
};
